/** The three colours Clu's mark is drawn in: its disc, beak and eyes. */
export interface CluColours {
  disc: string;
  beak: string;
  eye: string;
}

/** Clu's own: the app's blue, a touch toward indigo and a shade deeper. */
export const CLU_COLOURS: CluColours = {
  disc: '#3B5AF7',
  beak: '#2A43DE',
  eye: '#0E1668',
};
